import React, { useEffect, useState } from "react";
import "./Message.css";
import ChatIcon from "./ChatIcon";
import haisLogo from "../images/logo.svg";
import ReactMarkdown from "react-markdown";
import { useMessages } from "../contexts/MessageProvider";
import MessageFeedback from "./MessageFeedback";
import rehypeRaw from "rehype-raw";
import { useAuth } from "../contexts/AuthProvider";
import PatientSummaryPdf from "../pdf/PatientSummaryPdf";
import { pdf } from '@react-pdf/renderer';

function Message({
    content,
    customContent,
    role,
    stream,
    scrollToBottom,
    currentRef,
    messageId = null,
    displayFeedbackOptions = false,
    messageFeedback = null,
    displayPatientSummaryPdfOption = false,
    patient
}) {
    const isUser = role === "user";
    const { name } = useAuth();
    const [displayedText, setDisplayedText] = useState("");
    const { setIsStreaming, setLastStreamMessage, setFinishedStream } = useMessages();

    useEffect(() => {
        if (content !== undefined && !isUser && stream) {
            let currentIndex = 0;
            let text = "";

            const intervalId = setInterval(() => {
                if (currentIndex < content.length) {
                    text += content[currentIndex];
                    setDisplayedText(text);
                    currentIndex++;

                    setIsStreaming(true);
                    setFinishedStream(currentIndex === content.length);
                    setLastStreamMessage(content[currentIndex]);

                    scrollToBottom(currentRef);

                } else {
                    clearInterval(intervalId);
                    setIsStreaming(false);
                }
            }, 15);

            return () => clearInterval(intervalId);
        } else {
            setDisplayedText(content);
            setIsStreaming(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [content]);

    const exportSummaryPdf = async () => {
        try {
            const blob = await pdf(
                <PatientSummaryPdf
                    patient={patient}
                    patientSummary={content}
                />
            ).toBlob();

            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `resumo_clinico.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Erro ao gerar PDF com gráficos:", error);
        }
    };

    return (
        <div className={`chat-item ${isUser ? "user-chat-item" : "assistant-chat-item"}`}>
            <div className={`message ${isUser ? "" : "assistant-message"}`}>
                {isUser ? (
                    <>
                        <div>{displayedText}</div>
                        <div className="chat-icon">
                            <ChatIcon src={null} alt="Ícone do usuário" user={false} name={name} />
                        </div>
                    </>
                ) : (
                    <>
                        <div className="message-wrapper">
                            <div className="chat-icon">
                                <ChatIcon src={haisLogo} alt="Ícone do assistente" user={false} />
                            </div>
                            <div id={'message' + messageId} className="assistant-text-message">
                                {customContent ? (
                                    <div style={{ paddingBottom: "1rem" }}>{customContent}</div>
                                ) : (
                                    <ReactMarkdown rehypePlugins={[rehypeRaw]}>
                                        {displayedText}
                                    </ReactMarkdown>
                                )}
                            </div>
                        </div>
                    </>
                )}
            </div>
            {!isUser && displayFeedbackOptions &&
                <MessageFeedback
                    messageId={messageId}
                    messageFeedback={messageFeedback}
                    displayPatientSummaryPdfOption={displayPatientSummaryPdfOption}
                    exportSummaryPdf={exportSummaryPdf}
                    patient={patient} />}
        </div>
    );
}

export default Message;
